import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { CommonService } from '../../../_common/_service/user.service';

import { ConfirmDialogComponent } from '../../popup/confirm-dialog/confirm-dialog.component';
import { ConfirmNGNDialogComponent } from '../../popup/confirm-ngn-dialog/confirm-ngn-dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EncrDecrService } from '../../../_common/_service/EncrDecrService.service';

@Component({
  selector: 'app-pluginadd',
  templateUrl: './pluginadd.component.html',
  styleUrls: ['./pluginadd.component.scss']
})

export class PluginaddComponent implements OnInit {

  stringJson: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  ServiceName: any;
  data: any;
  sessionId: any;
  AddMoneyForm: FormGroup;
  token: any;
  OptionList: any;
  serviceCode: any;
  loadingspinner: boolean = false;
  commissionList: any;
  amt: any;
  commissionFee: any;
  commissionTotal: any;
  ActualAmount: any;
  show: any;
  IsCommission: any;
  flag: any;

  constructor(private authService: AuthService,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder, private encrDecrService: EncrDecrService,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private activatedRoute: ActivatedRoute

  ) {


    this.AddMoneyForm = this.fb.group({
      PaymentModeCode: ["GCD"],
      Amount: [],
      DeviceType: "web"
    })
  }


  ngOnInit(): void {

    // //////console.log("You came from this site: <b>" + document.referrer + "</b>");


    this.activatedRoute.queryParams.subscribe(params => {
      this.sessionId = params['id'];
      debugger
      if (this.sessionId != "") {
        this.serviceCode = "AMD";
        this.data = this.encrDecrService.get(this.sessionId);
        this.stringJson = JSON.parse(this.data);
        this.commissionFee = 0;
        this.commissionTotal = 0;
        this.IsCommission = this.stringJson.IsCommission;
        this.flag = this.stringJson.api_key;

        if (this.stringJson.amount) {
          //prod
          //this.token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiKzkxNzkwNjEzOTUyOSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2VtYWlsYWRkcmVzcyI6InJvaGl0LnNoYXJtYUBhaXR1bml2ZXJzYWwuY29tIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbW9iaWxlcGhvbmUiOiIrOTE3OTA2MTM5NTI5Iiwic2VydmljZWlkIjoiNyIsInVzZXJpZCI6ImIxYTAxNjNhLTBkZjUtNDYwZi1iM2I1LTdhMmM1ZDk2MTg3NyIsIkRUeXBlIjoiMyIsIkNCU0FjY291bnQiOiJFR1cwMDAwMDAxMzkiLCJleHAiOjE2OTY5NDYwOTF9.U-NTlGtabeeMXBZAApZIPLmJPYo3iiU1xwVGsdk_Il4";
          //staging 
          //this.token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiKzkxMDk3MTk1MDUwNDMiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJzdW1pdHNocjExMUB5b3BtYWlsLmNvbSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL21vYmlsZXBob25lIjoiKzkxMDk3MTk1MDUwNDMiLCJzZXJ2aWNlaWQiOiI3IiwidXNlcmlkIjoiN2QzOGExYzgtOGQ0My00MjdjLThlYjktOGM1NDIyMWE1NmUzIiwiRFR5cGUiOiI3IiwiQ0JTQWNjb3VudCI6IkVHVzAwMDAwNDMwMCIsImV4cCI6MTY3MDQ4NDk2MH0.ppqgvJy9mFDPQWELjQkhNnttGYoLV0jBvdCyV_XPp1U";

          this.gettokenmerchantplugin();
        }
      }
    });
  }


  get f() { return this.AddMoneyForm.controls; }

  changeMethod(event: any) {

    if (event.value == 'NBD') { //nigeria_bank debit
      this.show = 3;
      this.getServiceCommissionList(this.stringJson.amount, event.value, this.serviceCode);
    }
    else {
      this.show = 2;
      this.getServiceCommissionList(this.stringJson.amount, event.value, this.serviceCode);
    }

  }

  string1: any;
  AddmobileMoneyForm(post: any) {

    this.submitted = true;
    this.loadingspinner = true;

    //
    var post1 = {
      sessionId: this.sessionId,
      accountCode: post.PaymentModeCode,
      Amount: parseFloat(this.stringJson.amount),
      DeviceType: "web"
    }

    //  String obect to JSON
    this.stringJson = JSON.stringify(post1);

    this.authService.addMoneymerchantonlineRequest(this.stringJson).subscribe((response: { apiStatus: boolean; apiMessage: any; apiData: any; transactionStatus: any }) => {

      ////////console.log(response);
      this.loadingspinner = false;

      if (response.apiStatus == true) {
        if (post.PaymentModeCode == "NBD") {
          this.submitted = false;
          this.commissionFee = 0;
          this.commissionTotal = 0;
          this.ActualAmount = 0;

          this.openNGNbanktransferDialog(response.apiData.meta.authorization);

        }
        else if (post.PaymentModeCode == "GCD" || post.PaymentModeCode == "FCD") {

          this.data = response.apiData;

          this.submitted = false;
          this.commissionFee = 0;
          this.commissionTotal = 0;
          this.ActualAmount = 0;
          // //////console.log(response.apiData);
          window.location.href = response.apiData;

        }
      }
      else {
        this.submitted = false;
        this.commissionFee = 0;
        this.commissionTotal = 0;
        this.ActualAmount = 0;

        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {

        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );


  }


  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {

    //this.submitted = true;
    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, "7").subscribe((response:
      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {

      if (response.apiStatus == true) {

        this.commissionList = response.apiData;
        this.amt = Amountrequested;
        this.commissionFee = this.commissionList.totalCommission;
        this.commissionTotal = this.commissionList.totalAmount;
        this.ActualAmount = this.commissionList.actualAmount;

      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  getaddoptionList() {
    this.submitted = false;

    this.authService.getchannelList(this.serviceCode, "7").subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {

      if (response.apiStatus == true) {

        this.OptionList = response.apiData;

        var d = this.OptionList.addmoneyservice.filter((x: { code: any; }) => x.code != 'FCD');

        //;
        this.OptionList = d;
      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');

      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  openNGNbanktransferDialog(data: any) {

    this.submitted = true;

    const dialogRef = this.dialog.open(ConfirmNGNDialogComponent, {
      width: '950px',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want

      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      alert('If you deposit amount in given bank please wait to credit your account');
    });
  }



  gettokenmerchantplugin() {
    debugger;

    this.authService.gettokenmerchantplugin(this.stringJson.api_key).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {

      debugger;

      this.token = response.apiData;
      this.tokenStorageService.saveToken(this.token);
      this.getaddoptionList();
      debugger
      this.getServiceCommissionList(this.stringJson.amount, this.f.PaymentModeCode.value, this.serviceCode);


    }, (err: any) => {
      debugger;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

}
